// BFF: ○ none — routes the eight sub-screens; feature access and switches come from shared hooks.
export { default } from './Settings'
